
<div v-if="!skipFormLoading" class="md:mt-64 px-16 md:w-568 mx-auto">
  <h1 class="text-h2 text-center mb-16">Add details for sitters</h1>
  <p class="text-body text-center max-w-368 mx-auto mb-32 md:mb-16">You can always edit this later</p>

  <Popup v-model="showPopupError" popupHeader="Error generating your draft" @close="closePopup">
    <Button variant="primary" value="Try again" size="medium" class="w-full" @click.prevent="retryChatGPT" />
  </Popup>

  <form class="flex flex-col mx-auto md:shadow-md md:p-24 bg-grey-background-subdued md:bg-white">
    <div class="flex flex-col items-center">
      <Button
        size="large"
        class="rounded-3xl text-center w-full normal-case chat-gpt"
        variant="outlined"
        :loading="loading"
        @click.prevent="useChatGPT"
      >
        <AIIcon class="w-18 pr-4" /><span>Draft with AI</span>
      </Button>
      <p class="text-body mt-16 mb-32 md:mb-16 text-grey-text-subdued text-center text-small">
        OpenAI will use the information you have provided about this job to generate your job description. The generated output
        may contain errors. You agree to review it before publishing and understand you are responsible for the information you
        post.
        <a
          class="underline"
          href="https://support.sittercity.com/hc/en-us/articles/23699389621019-Write-your-job-description-with-OpenAI"
          target="_blank"
        >
          Learn more
        </a>
      </p>
    </div>
    <div class="mb-32">
      <TextArea
        id="job-headline"
        ref="headlineRef"
        v-model.trim="headline"
        type="text"
        labelName="Headline"
        :characterCounter="true"
        :minCharacters="minHeadlineCharacterLength"
        :maxCharacters="maxHeadlineCharacterLength"
        :rows="1"
        helperText="Be specific and include details about your job"
        :presenceRequired="true"
        @input="
          () => {
            aiGenerated = false;
          }
        "
      />
    </div>
    <div class="mb-32">
      <TextArea
        id="job-simple-description"
        ref="descriptionRef"
        v-model.trim="description"
        labelName="Description"
        :minCharacters="minDescriptionCharacterLength"
        :maxCharacters="maxDescriptionCharacterLength"
        :rows="8"
        :presenceRequired="true"
        @input="
          () => {
            aiGenerated = false;
          }
        "
      />
    </div>
    <div class="flex flex-row-reverse">
      <RouteStepperNextButton
        ref="routeStepperNextButton"
        :stepData="descriptionReviewSection"
        :draftData="draftData"
        :validate="validate"
        @errors="errors = $event"
      />
    </div>
  </form>
</div>
<div v-else class="flex items-center justify-center">
  <Spinner class="mt-224" :width="48" :height="48" />
</div>
